module.exports = __webpack_public_path__ + "static/media/earkohaddo.d54892d4.png";